<template>
  <div
    :class="useClass || 'mt-15 p-5 row between object-header c-v'"
    @click.stop="nameClick"
  >
    <div>
      <span
        class="collapse-toggle"
        @click.stop="toggle"
        >{{ collapsed.includes(path) ? "+" : "-" }}</span
      >
      <span class="node-path">
            {{descr || ''}}{{ path }}
        </span>
    </div>
    <slot>
        <div class="p-15" />
    </slot>
  </div>
</template>

<script>
export default {
    name: 'objectheader',
    props: [
        "nameClick", "toggle", "collapsed", "path", "descr", "useClass"
    ]
}
</script>